/** Estilos globales para impresión nativa (window.print) — MUI/Emotion siguen aplicando */
export const organigramaPrintGlobalStyles = {
  "@media screen": {
    ".organigrama-print-header": {
      display: "none",
    },
  },
  "@media print": {
    "@page": {
      size: "A4 portrait",
      margin: "10mm",
    },
    "@page organigrama-landscape": {
      size: "A4 landscape",
      margin: "8mm",
    },
    body: {
      WebkitPrintColorAdjust: "exact",
      printColorAdjust: "exact",
    },
    ".organigrama-no-print": {
      display: "none !important",
    },
    /* Solo el bloque de organigrama visible al imprimir */
    "body.organigrama-print-mode-chart *": {
      visibility: "hidden",
    },
    "body.organigrama-print-mode-chart .organigrama-print-root, body.organigrama-print-mode-chart .organigrama-print-root *":
      {
        visibility: "visible",
      },
    "body.organigrama-print-mode-chart .organigrama-print-root": {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      margin: "0 !important",
      padding: "8mm !important",
    },
    "body.organigrama-print-mode-funciones *": {
      visibility: "hidden",
    },
    "body.organigrama-print-mode-funciones .organigrama-print-root, body.organigrama-print-mode-funciones .organigrama-print-root *":
      {
        visibility: "visible",
      },
    "body.organigrama-print-mode-funciones .organigrama-print-root": {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      margin: "0 !important",
      padding: "8mm !important",
    },
    "body.organigrama-print-mode-all *": {
      visibility: "hidden",
    },
    "body.organigrama-print-mode-all .organigrama-print-root, body.organigrama-print-mode-all .organigrama-print-root *":
      {
        visibility: "visible",
      },
    "body.organigrama-print-mode-all .organigrama-print-root": {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      margin: "0 !important",
      padding: "8mm !important",
    },
    "body.organigrama-print-mode-chart .organigrama-section-funciones": {
      display: "none !important",
    },
    "body.organigrama-print-mode-chart .organigrama-section-chart": {
      display: "block !important",
      page: "organigrama-landscape",
    },
    "body.organigrama-print-mode-funciones .organigrama-section-chart": {
      display: "none !important",
    },
    "body.organigrama-print-mode-funciones .organigrama-section-funciones": {
      display: "block !important",
    },
    "body.organigrama-print-mode-all .organigrama-section-chart, body.organigrama-print-mode-all .organigrama-section-funciones":
      {
        display: "block !important",
      },
    "body.organigrama-print-mode-all .organigrama-section-funciones": {
      pageBreakBefore: "always",
      breakBefore: "page",
    },
    ".organigrama-print-header": {
      display: "block !important",
    },
    ".organigrama-chart-root": {
      overflow: "visible !important",
      minWidth: "0 !important",
      maxWidth: "none !important",
      width: "100% !important",
      boxShadow: "none !important",
    },
    ".organigrama-funciones-print": {
      display: "grid !important",
      gridTemplateColumns: "1fr !important",
      gap: "16px !important",
    },
    ".organigrama-funciones-print .MuiPaper-root, .organigrama-chart-root .MuiPaper-root": {
      breakInside: "avoid",
      pageBreakInside: "avoid",
      boxShadow: "none !important",
    },
  },
};

export const ORGANIGRAMA_PRINT_BODY_CLASSES = {
  chart: "organigrama-print-mode-chart",
  funciones: "organigrama-print-mode-funciones",
  all: "organigrama-print-mode-all",
};

export const clearOrganigramaPrintBodyClasses = () => {
  Object.values(ORGANIGRAMA_PRINT_BODY_CLASSES).forEach((cls) => {
    document.body.classList.remove(cls);
  });
};

export const runOrganigramaPrint = (mode) => {
  clearOrganigramaPrintBodyClasses();
  const cls = ORGANIGRAMA_PRINT_BODY_CLASSES[mode];
  if (!cls) return;
  document.body.classList.add(cls);
  requestAnimationFrame(() => {
    window.print();
  });
};
